import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { EditPropertyNotes } from '@components/custom'
import { EditButtonWrapper } from '@components/common'
import './Notes.scss'
import sanitizeHtml from 'sanitize-html'

const Notes = props => {
  const [isOpen, onEdit] = useState(false)
  const { notesContent, notesLimit, updateNotes, propertyLabel, height } = props
  const notesContentTrimmed = notesContent.trim()

  return (
    <>
      <EditButtonWrapper
        isTruncated={notesContentTrimmed?.length > notesLimit}
        handleEditButtonClick={() => onEdit(!isOpen)}
        dataTestId={`edit-${propertyLabel}-icon`}
      >
        <div
          className={`notes_wrap ${
            propertyLabel === 'sourcenotes'
              ? ''
              : notesLimit < 100
              ? 'sales_wrapper'
              : 'rent_wrapper'
          }`}
          id="i_notes"
          style={{ height }}
        >
          <span data-testid="notes-t1-header">
            {propertyLabel === 'sourcenotes' ? 'Source Notes:' : 'Notes:'}{' '}
          </span>
          {notesContentTrimmed && (
            (propertyLabel === 'sourcenotes' || propertyLabel.includes('salesnotes')) ? (
              <div className="notes_content" data-testid="notes-content">
                {notesContentTrimmed[0].toUpperCase() +
                  notesContentTrimmed.substring(1, notesLimit)}
              </div>
            ) : (
              <div className="notes_content" data-testid="notes-content" dangerouslySetInnerHTML={{
                __html: sanitizeHtml(notesContentTrimmed[0].toUpperCase() +
                  notesContentTrimmed.substring(1, notesLimit))
              }} />
            )
          )}
        </div>
      </EditButtonWrapper>
      <EditPropertyNotes
        isDialogOpen={isOpen}
        propertyNotes={notesContentTrimmed}
        notesLimit={notesLimit}
        editPropertyNotes={updateNotes}
        closeEditPopup={() => onEdit(!isOpen)}
        propertyLabel={propertyLabel}
      />
    </>
  )
}

Notes.propTypes = {
  notesContent: PropTypes.string,
  notesLimit: PropTypes.number,
  updateNotes: PropTypes.func,
  propertyLabel: PropTypes.string,
  height: PropTypes.string
}

export default Notes
